import { useSyncExternalStore } from 'react';

const TICK_MS = 30_000;
let current = Date.now();
let timer: ReturnType<typeof setInterval> | undefined;
const listeners = new Set<() => void>();

function subscribe(listener: () => void): () => void {
  if (listeners.size === 0) {
    current = Date.now();
    timer = setInterval(() => {
      current = Date.now();
      listeners.forEach((notify) => notify());
    }, TICK_MS);
  }
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
    if (listeners.size === 0) clearInterval(timer);
  };
}

/** The current time for rendering, refreshed every 30 s; pure from React's point of view. */
export function useNow(): number {
  return useSyncExternalStore(subscribe, () => current);
}
